export const getIDsFromArray = (arrayWithIDs) => (arrayWithIDs.map((el) => el.id));
